import {
	clusterListFetchSucceded,
	clusterDeleteSucceded
} from "components/management/cluster/actions";
import {
	CLUSTER_ACTION,
	ClusterDeleteRequestedAction
} from "components/management/cluster/types";
import ClustersApi from "modules/api/ClustersApi";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

function* fetchClusterList() {
	// console.log("fetchClusterList saga");

	try {
		const response = yield call(ClustersApi.fetchList);
		// console.log("saga cluster list fetched", response);

		yield put(clusterListFetchSucceded(response.data));
	} catch (e) {
		console.error(e);
	}
}

// function* createCluster(action: ClusterCreateRequestedAction) {
// 	yield call(ClustersApi.create, action.payload.cluster);
// 	yield put(clusterCreateSucceded(action.payload.cluster));
// }

function* deleteCluster(action: ClusterDeleteRequestedAction) {
	yield call(ClustersApi.delete, action.payload.cluster);
	yield put(clusterDeleteSucceded(action.payload.cluster.name));
}

function* ClusterSideEffects() {
	yield takeLatest(CLUSTER_ACTION.LIST_FETCH_REQUESTED, fetchClusterList);
	// yield takeEvery(CLUSTER_ACTION.CREATE_REQUESTED, createCluster);
	yield takeEvery(CLUSTER_ACTION.DELETE_REQUESTED, deleteCluster);
}

export default ClusterSideEffects;
